import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { lazyContextAddon10t74vogc7n59 as lazyContextAddon } from '../ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_overlayFrame(_this__u8e3s4, _set____db54di) {
  _init_properties_appBase_kt__bt6zr4();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_overlayFrame_$ref_166kt9();
  return overlayFrame$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('overlayFrame', 1, tmp, tmp_0, _set_overlayFrame_$ref_rwxo9j()), _set____db54di);
}
function get_overlayFrame(_this__u8e3s4) {
  _init_properties_appBase_kt__bt6zr4();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_overlayFrame_$ref_166kt9();
  return overlayFrame$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('overlayFrame', 1, tmp, tmp_0, _set_overlayFrame_$ref_rwxo9j()));
}
var overlayFrame$delegate;
function set_coordinatorFrame(_this__u8e3s4, _set____db54di) {
  _init_properties_appBase_kt__bt6zr4();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_coordinatorFrame_$ref_oiy9j7();
  return coordinatorFrame$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('coordinatorFrame', 1, tmp, tmp_0, _set_coordinatorFrame_$ref_akvliv()), _set____db54di);
}
function get_coordinatorFrame(_this__u8e3s4) {
  _init_properties_appBase_kt__bt6zr4();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_coordinatorFrame_$ref_oiy9j7();
  return coordinatorFrame$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('coordinatorFrame', 1, tmp, tmp_0, _set_coordinatorFrame_$ref_akvliv()));
}
var coordinatorFrame$delegate;
function overlayFrame$delegate$lambda(it) {
  _init_properties_appBase_kt__bt6zr4();
  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("'ElementContext.overlayFrame' has not been initialized, it must be set before dialogs, overlays, and popovers can be used. It is recommended to call 'appBase { ... }' at the root of your app to properly initialize overlayFrame, as well as many other properties.");
}
function _get_overlayFrame_$ref_166kt9() {
  return constructCallableReference((p0) => get_overlayFrame(p0), 1, 0, 124);
}
function _set_overlayFrame_$ref_rwxo9j() {
  return constructCallableReference((p0, p1) => {
    set_overlayFrame(p0, p1);
    return Unit_instance;
  }, 2, 0, 125);
}
function coordinatorFrame$delegate$lambda(it) {
  _init_properties_appBase_kt__bt6zr4();
  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("'ElementContext.coordinatorFrame' has not been initialized. It is recommended to call 'appBase { ... }' at the root of your app to properly initialize coordinatorFrame, as well as many other properties.");
}
function _get_coordinatorFrame_$ref_oiy9j7() {
  return constructCallableReference((p0) => get_coordinatorFrame(p0), 1, 0, 126);
}
function _set_coordinatorFrame_$ref_akvliv() {
  return constructCallableReference((p0, p1) => {
    set_coordinatorFrame(p0, p1);
    return Unit_instance;
  }, 2, 0, 127);
}
var properties_initialized_appBase_kt_zfmlr2;
function _init_properties_appBase_kt__bt6zr4() {
  if (!properties_initialized_appBase_kt_zfmlr2) {
    properties_initialized_appBase_kt_zfmlr2 = true;
    overlayFrame$delegate = lazyContextAddon(overlayFrame$delegate$lambda);
    coordinatorFrame$delegate = lazyContextAddon(coordinatorFrame$delegate$lambda);
  }
}
//region block: exports
export {
  set_coordinatorFrame as set_coordinatorFrame2x7bf8vqorao5,
  get_overlayFrame as get_overlayFrame1s8kw8rhusiwv,
  set_overlayFrame as set_overlayFramep1ecbdlnexqw,
};
//endregion

//# sourceMappingURL=appBase.mjs.map
